import { createSharedStoreHook } from 'shared-store-hook';

// Business identity. business_official_name is the IRS-registered legal entity
// (EIN holder) and must match the carrier SMS registration exactly;
// business_display_name is the trade name the site markets under.
//
// Exported on its own so non-React modules (e.g. services/contactApi) read the
// same values the pages render, instead of repeating them.
export const BUSINESS_IDENTITY = Object.freeze({
  business_official_name: '10 Space LLC',
  business_display_name: 'Tenspace Software',
  contact_phone: '505-600-1741',
  contact_email: 'support@10spacesoftware.com',
  contact_address: '603 S Public RD Unit 801, Lafayette, CO 80026',
});

export const useConfig = createSharedStoreHook({
  initialState: { ...BUSINESS_IDENTITY },
});
